import React from "react";
import Select from "components/common/Select";
class MultiSelect extends React.Component {
  constructor() {
    super(...arguments);
    this._select = void 0;
    this.getValue = () => this._select.getValue();
  }
  render() {
    return /* @__PURE__ */ React.createElement(
      Select,
      {
        ref: (c) => {
          this._select = c;
        },
        multi: true,
        ...this.props
      }
    );
  }
}
export default MultiSelect;
